import { render, staticRenderFns } from "./servAppraiseManageTable.vue?vue&type=template&id=f06a88ce&scoped=true"
import script from "./servAppraiseManageTable.vue?vue&type=script&lang=js"
export * from "./servAppraiseManageTable.vue?vue&type=script&lang=js"
import style0 from "./servAppraiseManageTable.vue?vue&type=style&index=0&id=f06a88ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06a88ce",
  null
  
)

export default component.exports